(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "../Utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("../Utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Utils);
    global.reducer = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _Utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.RESET_FILTERS = _exports.REPLACE_FILTERS = _exports.REMOVE_FILTER = _exports.ADD_FILTER = void 0;
  _exports["default"] = reducer;
  _exports.replaceFilters = replaceFilters;
  _exports.resetFilters = resetFilters;
  _exports.toggleFilter = toggleFilter;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ADD_FILTER = _exports.ADD_FILTER = 'app/facets/ADD_FILTER';
  var REMOVE_FILTER = _exports.REMOVE_FILTER = 'app/facets/REMOVE_FILTER';
  var REPLACE_FILTERS = _exports.REPLACE_FILTERS = 'app/facets/REPLACE_FILTERS';
  var RESET_FILTERS = _exports.RESET_FILTERS = 'app/facets/RESET_FILTERS';
  var initialState = {
    filters: {}
  };
  function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    switch (action.type) {
      case ADD_FILTER:
        {
          return _objectSpread(_objectSpread({}, state), {}, {
            // Add or update the filter to the filters list, for the given key
            filters: _objectSpread(_objectSpread({}, state.filters), {}, _defineProperty({}, action.attribute, action.value))
          });
        }
      case REMOVE_FILTER:
        {
          var updatedFilters = _objectSpread({}, state.filters);
          delete updatedFilters[action.attribute];
          return _objectSpread(_objectSpread({}, state), {}, {
            filters: updatedFilters
          });
        }
      case REPLACE_FILTERS:
        {
          return _objectSpread(_objectSpread({}, state), {}, {
            filters: _objectSpread({}, action.filters)
          });
        }
      case RESET_FILTERS:
        {
          return initialState;
        }
      default:
        return state;
    }
  }
  function replaceFilters(filters) {
    return {
      type: REPLACE_FILTERS,
      filters: filters
    };
  }
  function resetFilters() {
    return {
      type: RESET_FILTERS
    };
  }
  function toggleFilter(attribute, value) {
    if (!value || Array.isArray(value) && value.length === 0) {
      return {
        type: REMOVE_FILTER,
        attribute: attribute
      };
    }
    // Decode the value before passing in as sanitize value as sanitize value will remove any symbols
    // that helps in decoding.
    var decodedString = decodeURIComponent(value);
    var sanitizedValue = (0, _Utils.sanitizeString)(decodedString);
    return {
      type: ADD_FILTER,
      attribute: attribute,
      value: sanitizedValue
    };
  }
});